import React from 'react'

export const Link = ({ to, children, ...props }) => {
    return <a href={to} {...props}>{children}</a>
}
